import { render, staticRenderFns } from "./dialog-managestoragestaff.vue?vue&type=template&id=7c533d50&"
import script from "./dialog-managestoragestaff.vue?vue&type=script&lang=js&"
export * from "./dialog-managestoragestaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports